/**
 * SessionStorage key used to persist the intended navigation path
 * across the MSAL authentication flow.
 * 
 * Flow: IsAuthenticated saves path → MSAL popup auth → Login reads path
 */
export const SESSION_STORAGE_REDIRECT_KEY = 'intended_path'

/**
 * Valid path prefixes for post-login redirect.
 * Prevents navigation to unexpected routes after authentication.
 */
export const VALID_REDIRECT_PREFIXES = [
  '/home',
  '/farm',
  '/data',
  '/genie',
  '/transmission',
  '/job-assistant',
  '/map'
] as const
